import { MetaProductType } from '../enums/meta-product-type.enum';
import { ProductAttributeKey } from '../enums/product-attribute-key.enum';
export var isProductSoftware = function (product) {
    var attributes = product.attributes;
    return (attributes || []).some(function (x) {
        return x.key === ProductAttributeKey.MetaProductType && x.valueKey === MetaProductType.Software;
    });
};
